import { DynamicStandaloneJwVideoArticle } from '@/components/JwVideo/Article';
import { LabradorComponent } from '@/types/component';
import withDebugMetadata from '@/utils/withDebugMetadata';
import { getB2BVideoInfo, getVideoOptions } from 'base/components/JwVideo/Article/utils/dataParser';

const LabradorVideoArticle: LabradorComponent = ({ data, meta, type }) => {
  const videoOptions = getVideoOptions(data);
  const b2bVideoInfo = getB2BVideoInfo(data);

  const { enableDesc, fieldSettings, durationMinutes, playerID, teaserLink, metadata } = data;

  const titleTextSize = fieldSettings?.title?.textSize;

  return (
    <DynamicStandaloneJwVideoArticle
      playerId={playerID}
      videoData={videoOptions}
      b2bVideo={b2bVideoInfo}
      showDescription={enableDesc}
      durationMinutes={durationMinutes}
      videoPageLink={teaserLink}
      titleTextSize={titleTextSize}
      metadata={metadata}
      disableLazyLoad
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export default LabradorVideoArticle;
